<template>
  <div class="home">
      <!-- <Navbar></Navbar> -->
      <div class="content">
          <div class="weimaqi"><img src="./images/logo-icon.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
          <div class="title">维码器，为你实现更多</div>
            <div class="write">
                WEIMAQI , DO MORE FOR YOU
            </div>
            <div class="port">
                <div class="one">
                    <div class="imgae"><img src="./images/icon01.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                    <div class="word">为商家<br/>实现更多收益</div>
                    <div class="line"></div>
                </div>
                <div class="two">
                    <div class="imgae"><img src="./images/icon02.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                    <div class="word">为会员<br/>实现更多优惠</div>
                    <div class="line"></div>
                </div>
                <div class="three">
                    <div class="imgae"><img src="./images/icon03.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                    <div class="word">为行业<br/>实现更多改变</div>
                    <div class="line"></div>
                </div>
            </div>
      </div>
  </div>
</template>
<script>
import Navbar from '../Navbar'
export default {
  name:'home1',
  components:{Navbar},
  mounted () {
      this.$store.state.d4 = ''
  }
}
</script>

<style scoped>
/* .home .header{
    position: absolute;
    z-index: 0;
} */
/* .home .header nav .nav li a{
    color: #fff;
}
.home .header .fa.fa-bars{
    color: #fff;
}
.home .header .logo{
     background: url(../../assets/logo-white.png) no-repeat;
    background-size: cover;
    width: 119px;
    height: 24px;
} */
.home{
    width:100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #fafafa;
    background: url(./images/bg.jpg) no-repeat;
    background-size: cover;
}
.content{
    width: 800px;
	height: 450px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
}
.weimaqi{
    width: 76px;
	height: 75px;
}
.title{
font-family: 微软雅黑;
font-size: 50px;
letter-spacing: 5px;
height: 50px;
line-height: 50px;
letter-spacing: 5px;
color: #fafafa;
}
.write{
font-family: Arial;
font-size: 18px;
letter-spacing: 0px;
color: #fafafa;
text-align: center;
}
.port{
width: 800px;
height: 150px;
display: flex;
justify-content: space-between;
align-items: center;
}
.word{
    font-size: 16px;
    font-family: 微软雅黑;
	line-height: 24px;
	letter-spacing: 0px;
	color: #fafafa;
    text-align: center;
}
.line{
    width: 20px;
	height: 2px;
	background-color: #1a8bff;
}
.one,.two,.three{
    width:100px;
    height: 141px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
}
@media screen and (max-height:800px){
    .layer{
        transform: scale(0.8);
    }
}

/* 手机 */
@media screen and (max-width:768px){
.home{
width:100%;
height: 100vh;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
background-color: #fafafa;
background: url(./images/phone/BG.jpg) no-repeat;
background-size: cover;
}
.content{
    width: 100%;
    height: 240px;
    padding: 0px 35px;
    box-sizing: border-box;
}
.content .weimaqi{
    width: 38px;
    height: 38px;
}
.content .weimaqi img{
    width: 100%;
}
.content .title{
font-size: 22px;
letter-spacing: 2px;
margin-top:34px;
color: #fafafa;
}
.content .write{
font-size: 11px;
color: #fafafa;
margin-top:14px;
text-align: center;
}
.content .port{
    width: 100%;
    height: 80px;
    margin-top:43px;
}
.port .imgae{
    width: 25px;
    height: 17px;
}
.port .imgae img{
    width: 100%;
}
.content .word{
    font-size: 11px;
	line-height: 18px;
    font-family: "Times New Roman",Georgia,Serif;
	color: #fafafa;
    text-align: center;
}
.content .line{
    width: 10px;
	height: 1px;
	background-color: #1a8bff;
}
.content .one,.content .two,.content .three{
    width: 30%;
    height: 80px;
    justify-content: space-between;
}
}
</style>




// WEBPACK FOOTER //
// src/components/coopera/home1.vue